import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import * as React from "react";
import {ImgTileLink} from "../../../../components/ImgTileLink";
import {resourcesHelper,
    ICustomerPortalService,
    Types
} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {lazyInject} from "@athena-portal/core";
import { scrollToTop } from "../../../../CommonFunctions";

interface IState {
    name?: string;
}

@authorize
export class AllianzAdvantagePagePlain extends React.Component<IWithRouterProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps) {
        super(props);

        this.state = {
            name: ""
        }
    }

    public componentDidMount() {
        this.customerPortalService.getProfile().subscribe(party => {
            const name = party?.firstName;
            this.setState({name});
        })

        scrollToTop();
    }

    public render() {
        return (<>
            <FalconHeader/>

            {this.renderMainImage()}
            {this.renderAllianzAdvantagesHeader()}
            <div className={`advantage-background`}>
                <div className="advantage-background dashboard-page pt-3">
                    {this.renderTiles()}
                </div>
            </div>
            {this.renderMainImageFooter()}
            {this.renderLatestNews()}
            <FalconFooter/>
        </>)
    }

    private renderTiles(): React.ReactNode {
        return (<div className="link-grid ">
            <div className="d-flex flex-wrap flexItemAdvantage">

                <div className="flexItem advantageItem quotes">
                    <ImgTileLink id="quotes"
                                 src={`/${resourcesHelper.THEME}/img/savings_icon.png`}
                                 alt="Save with Allianz"
                                 additionalText="Discounts from loads of top brands"
                                 to="https://allianz-advantages.memberrewards.uk/a_"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        Save with Allianz
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem savings">
                    <ImgTileLink id="savings"
                                 src={`/${resourcesHelper.THEME}/img/gift_icon.svg`}
                                 alt="Win with Allianz"
                                 additionalText="Check out our latest free prize draw"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/win-with-allianz.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        Win with Allianz
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem advantages-hands-stars">
                    <ImgTileLink id="advantages-hands-stars"
                                 src={`/${resourcesHelper.THEME}/img/advantage-hands-stars.svg`}
                                 alt={`The ${resourcesHelper.THEME} difference`}
                                 additionalText="Special offers exclusive to our customers"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/allianz-difference.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        The {resourcesHelper.THEME} difference
                    </ImgTileLink>
                </div>

                <div className="flexItem advantageItem advantages-stadium">
                    <ImgTileLink id="advantages-stadium"
                                 src={`/${resourcesHelper.THEME}/img/advantage-stadium.svg`}
                                 alt={`${resourcesHelper.THEME} stadium rewards`}
                                 additionalText="Discounted stadium tours and rugby tickets"
                                 to="https://www.allianz.co.uk/insurance/customer-offers/allianz-stadium-rewards.html"
                                 hasInfoButton={false}
                                 openInNewWindow={true}
                                 {...this.props}>
                        {resourcesHelper.THEME} stadium rewards
                    </ImgTileLink>
                </div>
            </div>
            </div>)
    }

    private renderMainImage() {
        return (
            <div className={`advantages-main-image-wrapper`}>
                <img src={`/${resourcesHelper.THEME}/img/v2-advantages-landing-page-header.png`} alt={`${resourcesHelper.THEME} Advantages`}/>
            </div>
        )
    }
    private renderAllianzAdvantagesHeader() {
        return (
            <div className={`page-contents-advantages page-contents dashboard-page pt-3 pr-5`}>
                <div className={`advantage-text-block`}>
                    <div className={`mt-3 mb-3`}>
                        <a className={`advantages-blue-link mt-3 ml-1`} href={`/dashboard`}>
                            <img src={`/${resourcesHelper.THEME}/img/back-arrow-blue.svg`} className={`mr-2`} alt={`Back to dashboard`}/>
                            <u>Back to dashboard</u></a>
                    </div>
                    <img className={`allianz-advantages-img`} src={`/${resourcesHelper.THEME}/img/allianz-advantages-logo.svg`}  alt={`${resourcesHelper.THEME} advantages`}/>
                    <p className={`font-weight-bold mt-1`}> {this.state?.name}, check out your latest offers, discounts and prizes...</p>
                </div>
            </div>
        )
    }

    private renderMainImageFooter() {
        return (
            <div className={`advantage-main-image-footer-background`}>
                <div className={`advantage-main-image-footer-content`}>
                    <div className={`d-inline-block advantage-main-image-footer-gift-background`}>
                        <img className={`advantage-main-image-footer-gift`}
                            src={`/${resourcesHelper.THEME}/img/gift-white.svg`}  alt={`${resourcesHelper.THEME} advantages`}/>
                    </div>
                    <div className={`advantages-footer-helper`}>
                        <h1 className={`advantages-main-image-footer-title`}>What's new</h1>
                        <p className={`advantages-main-image-footer-text`}>Get discounts off your car service and MOT from Halfords</p>
                        <a className={`advantages-blue-link`} href={`https://www.allianz.co.uk/insurance/customer-offers/halfords.html`}><u>View this offer </u>
                            <img className={`mr-1`} src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}  alt={`View this offer`}/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }

    private renderLatestNews() {
        return (
            <div className="d-flex flex-wrap flexItemAdvantage">
                <div className={`advantage-footer-about dashboard-page mt-5`}>
                    <img
                        src={`/${resourcesHelper.THEME}/img/envelop.svg`}  alt={`Latest offer`}/>
                    <h1 className={`advantage-tile-header mb-1 mt2`}>Want to hear about our latest offers?</h1>
                    <p>Make sure you sign up to our marketing communications to receive notifications of new offers and rewards.</p>
                    <a className={`font-weight-bold`} href={`/dashboard/marketing-preferences`}
                       onClick={this.onMarketingPreferencesClick}><u>My marketing preferences</u> <img
                        className={`ml-1`} src={`/img/arrow-right.svg`} alt={`${resourcesHelper.THEME} Advantages`}/>
                    </a>
                </div>
            </div>
        )
    }

    private onMarketingPreferencesClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        if (resourcesHelper.THEME !== "Allianz") {
            return;
        }

        window.adobeDataLayer = window.adobeDataLayer || [];
        window.adobeDataLayer.push({
            event: "componentClick",
            componentInfo: {
                componentName: "advantages_opt_in",
                componentType: "pod",
                componentBannerName: "My marketing preferences",
                componentBannerLink: event.currentTarget.href,
            },
        });
    }
}

export const AllianzAdvantagePage = withRouter(AllianzAdvantagePagePlain)
